import { render } from "./FrmWorkersActivity.vue?vue&type=template&id=289a392a"
import script from "./FrmWorkersActivity.vue?vue&type=script&lang=js"
export * from "./FrmWorkersActivity.vue?vue&type=script&lang=js"

import "./FrmWorkersActivity.vue?vue&type=style&index=0&id=289a392a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__